/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF , Text } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { Debug } from "@react-three/rapier";
import { PointerLockControls } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("/campus-v1.glb");
  var collision = new Audio('collision.mp3');
  
  return (
    <group {...props} dispose={null}>
      {/* <Debug/>
      <RigidBody colliders="hull">
      <mesh position={[0,0,40]} scale={0.5}> 
        <sphereGeometry/>
        <meshPhongMaterial color="red" />
      </mesh>
        </RigidBody>  */}

      <group
        position={[-21.17, 3.647, 1.492]}
        rotation={[Math.PI, -0.805, Math.PI]}
        scale={0.486}
      >

        <mesh
          geometry={nodes.Vue001.geometry}
          material={materials["Vue Green 02.001"]}
          position={[-18.521, 0.169, -14.828]}
          rotation={[0, 0.701, 0]}
          scale={2.494}
        />
        <mesh
          geometry={nodes.Vue.geometry}
          material={materials["Vue Green 01.001"]}
          position={[-18.521, 0.169, -14.828]}
          rotation={[0, 0.701, 0]}
          scale={[2.494, 2.494, 5.444]}
        />
      </group>
      <group
        position={[-19.558, 1.638, 3.564]}
        rotation={[2.966, -0.606, -2.896]}
        scale={0.029}
      >
        <mesh
          geometry={nodes.threejs.geometry}
          material={materials.Material_0}
          position={[-388.303, 203.056, 14.357]}
          rotation={[0.37, 0.918, -0.326]}
          scale={[0.833, 0.833, 2.693]}
        />
      </group>
      <group
        position={[-9.313, 1.652, 4.669]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
        scale={0.009}
      >
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Cube_Material_0.geometry}
              material={materials["Vue Green 02.001"]}
              position={[0.003, -0.212, 0.544]}
              scale={[0.694, 3.594, 0.694]}
            />
          </group>
          <group rotation={[-Math.PI / 2, 0, 0]} scale={100}>
            <mesh
              geometry={nodes.Cylinder_Material_0.geometry}
              material={materials["Material.009"]}
              position={[0.003, -0.132, 0.544]}
              scale={[0.694, 2.464, 0.694]}
            />
          </group>
        </group>
      </group>
      <group
        position={[-14.673, 3.086, 9.509]}
        rotation={[-Math.PI / 2, 0, -Math.PI]}
        scale={0.064}
      >
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <group position={[-0.001, 0, -0.001]}>
            <group
              position={[-0.001, 0, 199.567]}
              rotation={[-Math.PI / 2, 0, 0]}
              scale={100}
            >
              <mesh
                geometry={nodes["C++_C++_0"].geometry}
                material={materials.material}
                position={[-40.692, 39.193, -6.131]}
                scale={0.595}
              />
            </group>
          </group>
        </group>
      </group>
      <group
        position={[-16.296, 2.793, 11.602]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.034}
      >
        <group rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <group position={[0, -0.001, 0]}>
            <group
              position={[0, -0.001, 0]}
              rotation={[-Math.PI / 2, 0, 0]}
              scale={100}
            >
              <mesh
                geometry={nodes.Python_Python_0.geometry}
                material={materials.Python}
                position={[5.397, 0, 0]}
              />
            </group>
          </group>
        </group>
      </group>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group scale={[1.242, 2.034, 0.621]}>
            <group position={[148.381, -48.827, 0]}>
              <mesh
                geometry={nodes["Youtube_Logo_01_-_Default_0"].geometry}
                material={materials["01_-_Default"]}
                position={[-162.991, 54.075, 17.881]}
                rotation={[Math.PI, 0, Math.PI]}
                scale={0.004}
              />
            </group>
          </group>
        </group>
      </group>
      <mesh
        geometry={nodes.Vert.geometry}
        material={materials["Material.016"]}
        position={[-5.852, 3.22, 12.114]}
        rotation={[3.06, 0.022, -3.11]}
        scale={1.004}
      />
      <mesh castShadow
        geometry={nodes.Cube058.geometry}
        material={materials["Material.002"]}
        position={[55.863, 6.263, -19.198]}
        scale={0.6}
      />
      <mesh
        geometry={nodes.Text007.geometry}
        material={materials["Material.011"]}
        position={[41.833, 1.614, 10.317]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Cylinder001.geometry}
        material={materials["Material.016"]}
        position={[-5.851, 3.201, 12.054]}
        rotation={[3.06, 0.022, -3.11]}
        scale={[0.239, 0.016, 0.178]}
      />
      
      <Text scale={5} position={[18.539, 4, -15.5]}>Your Project Could be Here</Text>
     
      <RigidBody colliders="hull"  onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh 
        geometry={nodes.Text003.geometry}
        material={materials["Material.006"]}
        position={[9.856, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>

      <RigidBody colliders="hull" onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh 
        geometry={nodes.Text004.geometry}
        material={materials["Material.006"]}
        position={[8.36, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      />
      </RigidBody>

      <RigidBody colliders="hull" onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh 
        geometry={nodes.Text005.geometry}
        material={materials["Material.006"]}
        position={[6.867, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>
      
      <mesh
      onClick={(e) =>  
        window.open(
        "https://github.com/teleansh", "_blank")
        }
        geometry={nodes.Cylinder002.geometry}
        material={materials["Material.017"]}
        position={[-5.849, 3.2, 12.185]}
        rotation={[1.489, -0.032, -3.12]}
        scale={1.435}
      />
      <RigidBody type="fixed" colliders="trimesh">
      <mesh castShadow onClick={(e) =>  e.stopPropagation()}
        geometry={nodes.Cube003.geometry}
        material={materials["Material.012"]}
        position={[4.515, 3.539, -16.368]}
        rotation={[Math.PI, Math.PI / 2, 0]}
        scale={[-1, -1, -1.717]}
      /> </RigidBody> <RigidBody>
      <mesh receiveShadow
        geometry={nodes.Cube005.geometry}
        material={materials["Material.003"]}
        position={[5.391, 3.539, 2.548]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.642]}
      /></RigidBody>

      
      <RigidBody type="fixed" colliders="trimesh">
      <mesh  castShadow receiveShadow
      onClick={(e) =>  e.stopPropagation()}
        geometry={nodes.Cube006.geometry}
        material={materials["Material.003"]}
        position={[-8.857, 3.539, 2.577]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.642]}
      /></RigidBody>

      <RigidBody type="fixed" colliders="trimesh">
      <mesh receiveShadow
      onClick={(e) =>  e.stopPropagation()}
        geometry={nodes.Cube001.geometry}
        material={materials["Material.012"]}
        position={[4.639, 3.539, 12.63]}
        rotation={[Math.PI, Math.PI / 2, 0]}
        scale={[-1, -1, -2.843]}
      /></RigidBody>

<RigidBody type="fixed">
      <mesh onClick={(e) =>  e.stopPropagation()}
        geometry={nodes.Cube004.geometry}
        material={materials["Material.012"]}
        position={[46.614, 3.539, -1.784]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.988]}
      /> </RigidBody>

      <RigidBody type="fixed">
      <mesh onClick={(e) =>  e.stopPropagation()}
        geometry={nodes.Cube002.geometry}
        material={materials["Material.012"]}
        position={[-37.473, 3.539, -1.784]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.988]}
      />
      </RigidBody>
      
      <RigidBody colliders="hull" type="fixed">
      <mesh
        geometry={nodes.Cube.geometry}
        material={materials["Material.003"]}
        position={[-26.585, 3.541, 9.916]}
        rotation={[Math.PI / 2, 0, Math.PI / 2]}
      /></RigidBody>
      <mesh castShadow
        geometry={nodes.Cube007.geometry}
        material={materials["Material.007"]}
        position={[-26.201, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube008.geometry}
        material={materials["Material.007"]}
        position={[-36.817, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube009.geometry}
        material={materials["Material.007"]}
        position={[-31.613, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Text011.geometry}
        material={materials["Material.011"]}
        position={[6.956, 1.614, 5.482]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
      />
      
      <mesh castShadow
        geometry={nodes.Cube010.geometry}
        material={materials["Material.007"]}
        position={[-21.445, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube011.geometry}
        material={materials["Material.007"]}
        position={[-29.054, 6.727, -21.383]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube012.geometry}
        material={materials["Material.007"]}
        position={[-29.135, 6.727, -32.018]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube013.geometry}
        material={materials["Material.007"]}
        position={[-29.07, 6.727, -26.545]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube014.geometry}
        material={materials["Material.007"]}
        position={[-28.888, 6.727, -16.273]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <RigidBody type="fixed">
      <mesh castShadow
        geometry={nodes.Cube015.geometry}
        material={materials["Material.007"]}
        position={[-21.512, 3.177, -31.918]}
        rotation={[Math.PI, 0, 0]}
        scale={[1, 0.461, 1]}
      /></RigidBody>
      <mesh castShadow
        geometry={nodes.Cube016.geometry}
        material={materials["Material.007"]}
        position={[-36.803, 3.177, -31.933]}
        rotation={[Math.PI, 0, 0]}
        scale={[1, 0.461, 1]}
      />
      <mesh castShadow
        geometry={nodes.Cube017.geometry}
        material={materials["Material.009"]}
        position={[-7.809, 14.115, 3.991]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube018.geometry}
        material={materials["Material.009"]}
        position={[-4.656, 14.115, 3.991]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube019.geometry}
        material={materials["Material.009"]}
        position={[-1.327, 14.115, 3.991]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube020.geometry}
        material={materials["Material.009"]}
        position={[2.216, 14.115, 3.991]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube022.geometry}
        material={materials["Material.009"]}
        position={[-15.116, 14.115, 6.713]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[1, 0.648, 1]}
      />
      
      <mesh castShadow
        geometry={nodes.Cube023.geometry}
        material={materials["Material.009"]}
        position={[-11.551, 14.115, 5.41]}
        rotation={[Math.PI / 2, 0, -Math.PI]}
        scale={[-1, -0.85, -1]}
      /> 
      <mesh castShadow
        geometry={nodes.Cube024.geometry}
        material={materials["Material.009"]}
        position={[-19.051, 14.115, 8.377]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[1, 0.45, 1]}
      />
      <mesh castShadow
        geometry={nodes.Cube035.geometry}
        material={materials["Material.004"]}
        position={[25.533, 6.649, 10.914]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh castShadow
        geometry={nodes.Cube036.geometry}
        material={materials["Material.004"]}
        position={[18.539, 6.649, -14.664]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[0.553, 1, 1]}
      />
      <mesh castShadow
        geometry={nodes.Cube037.geometry}
        material={materials["Material.004"]}
        position={[7.024, 6.649, 1.863]}
        rotation={[-Math.PI / 2, 0, Math.PI / 2]}
        scale={[0.423, 1, 1]}
      />
      <mesh
        geometry={nodes.Text009.geometry}
        material={materials["Material.011"]}
        position={[21.248, 1.614, 10.317]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh castShadow
        geometry={nodes.Cube025.geometry}
        material={materials["Material.007"]}
        position={[41.231, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh castShadow
        geometry={nodes.Cube026.geometry}
        material={materials["Material.007"]}
        position={[30.641, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Text022.geometry}
        material={materials["Material.015"]}
        position={[-3.087, 11.495, 11.039]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />

      
      <mesh castShadow
        geometry={nodes.Cube027.geometry}
        material={materials["Material.007"]}
        position={[35.818, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      /> 
      <mesh castShadow
        geometry={nodes.Cube028.geometry}
        material={materials["Material.007"]}
        position={[45.986, 6.727, -23.903]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Cube029.geometry}
        material={materials["Material.007"]}
        position={[38.292, 6.727, -21.383]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube030.geometry}
        material={materials["Material.007"]}
        position={[38.297, 6.727, -32.018]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube031.geometry}
        material={materials["Material.007"]}
        position={[38.251, 6.727, -26.545]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube032.geometry}
        material={materials["Material.007"]}
        position={[38.314, 6.727, -16.273]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube033.geometry}
        material={materials["Material.007"]}
        position={[45.919, 3.177, -31.918]}
        rotation={[Math.PI, 0, 0]}
        scale={[1, 0.461, 1]}
      />
      <RigidBody type="fixed">
      <mesh castShadow
        geometry={nodes.Cube034.geometry}
        material={materials["Material.007"]}
        position={[30.629, 3.177, -31.933]}
        rotation={[Math.PI, 0, 0]}
        scale={[1, 0.461, 1]}
      /></RigidBody>
      <mesh
        geometry={nodes.Cube038.geometry}
        material={materials["Material.010"]}
        position={[41.794, 3.645, 12.103]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Cube040.geometry}
        material={materials["Material.010"]}
        position={[21.23, 3.645, 12.103]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Cube041.geometry}
        material={materials["Material.010"]}
        position={[10.659, 3.645, 12.103]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <mesh
        geometry={nodes.Cube042.geometry}
        material={materials["Material.010"]}
        position={[5.908, 3.645, 5.47]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh
        geometry={nodes.Text024.geometry}
        material={nodes.Text024.material}
        position={[-5.562, 8, -0.154]}
        rotation={[0, -0.85, 0]}
        scale={0.496}
      />
      <mesh
        geometry={nodes.Cube021.geometry}
        material={materials["Material.010"]}
        position={[31.666, 3.645, 12.103]}
        rotation={[-Math.PI / 2, 0, 0]}
      />
      <RigidBody type="fixed">
      <mesh 
        geometry={nodes.Cube039.geometry}
        material={materials["Material.012"]}
        position={[-37.473, 3.539, -30.722]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.988]}
      />
      <mesh
        geometry={nodes.Cube044.geometry}
        material={materials["Material.012"]}
        position={[46.614, 3.539, -31.065]}
        rotation={[-Math.PI, 0, -Math.PI]}
        scale={[1, 1, 0.988]}
      />
      <mesh
        geometry={nodes.Cube045.geometry}
        material={materials["Material.012"]}
        position={[31.416, 3.539, -45.448]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[1, 1, 0.988]}
      />
      <mesh
        geometry={nodes.Cube046.geometry}
        material={materials["Material.012"]}
        position={[-23.086, 3.539, -45.832]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[1, 1, 0.988]}
      /></RigidBody>
      <mesh castShadow
        geometry={nodes.Cube047.geometry}
        material={materials["Material.002"]}
        position={[17.622, 6.263, -52.106]}
        scale={0.6}
      />

      <RigidBody type="fixed">
      <mesh
        geometry={nodes.Cube048.geometry}
        material={materials["Material.005"]}
        position={[17.76, 1.691, -52.375]}
        scale={0.649}
      /></RigidBody>
      <mesh
        geometry={nodes.Text029.geometry}
        material={materials["Material.011"]}
        position={[2.82, 2.118, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />
      <mesh castShadow
        geometry={nodes.Cube049.geometry}
        material={materials["Material.002"]}
        position={[-11.448, 5.69, -52.24]}
        rotation={[0, -1.094, 0]}
        scale={0.6}
      />

<RigidBody type="fixed">
      <mesh castShadow
        geometry={nodes.Cube050.geometry}
        material={materials["Material.005"]}
        position={[-11.146, 1.691, -52.24]}
        rotation={[0, -1.094, 0]}
        scale={0.649}
      /> </RigidBody>

      <mesh castShadow
        geometry={nodes.Cube051.geometry}
        material={materials["Material.004"]}
        position={[4.078, 11.913, -45.866]}
        rotation={[0, 0, Math.PI / 2]}
      />
      <mesh castShadow
        geometry={nodes.Cube052.geometry}
        material={materials["Material.002"]}
        position={[-41.928, 5.69, 21.943]}
        rotation={[0, -1.094, 0]}
        scale={0.6}
      />
      <mesh
        geometry={nodes.Text012.geometry}
        material={materials["Material.011"]}
        position={[6.956, 1.614, -1.559]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
      />

<RigidBody type="fixed">
      <mesh
        geometry={nodes.Cube053.geometry}
        material={materials["Material.005"]}
        position={[-41.626, 1.691, 21.943]}
        rotation={[0, -1.094, 0]}
        scale={0.649}
      /> </RigidBody>

      <mesh castShadow
        geometry={nodes.Cube054.geometry}
        material={materials["Material.002"]}
        position={[-15.938, 5.69, 37.979]}
        rotation={[0, -1.094, 0]}
        scale={0.6}
      />

<RigidBody type="fixed">
      <mesh
        geometry={nodes.Cube055.geometry}
        material={materials["Material.005"]}
        position={[-15.635, 1.691, 37.979]}
        rotation={[0, -1.094, 0]}
        scale={0.649}
      /> </RigidBody>

      <mesh castShadow
        geometry={nodes.Cube056.geometry}
        material={materials["Material.002"]}
        position={[53.808, 5.69, 29.672]}
        rotation={[0, -1.094, 0]}
        scale={0.6}
      />

<RigidBody type="fixed">
      <mesh
        geometry={nodes.Cube057.geometry}
        material={materials["Material.005"]}
        position={[54.111, 1.691, 29.672]}
        rotation={[0, -1.094, 0]}
        scale={0.649}
      /> 

      <mesh
        geometry={nodes.Cube059.geometry}
        material={materials["Material.005"]}
        position={[56.002, 1.691, -19.467]}
        scale={0.649}
      />
    </RigidBody>

      <mesh
        geometry={nodes.Text021.geometry}
        material={nodes.Text021.material}
        position={[-30.796, 1.626, 11.637]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={0.272}
      />
      <mesh
        geometry={nodes.Cube043.geometry}
        material={materials["Material.010"]}
        position={[5.908, 3.645, -1.617]}
        rotation={[-Math.PI / 2, 0, -Math.PI / 2]}
      />
      <mesh 
        geometry={nodes.Text001.geometry}
        material={materials["Material.011"]}
        position={[27.37, 4.887, -17.088]}
        rotation={[Math.PI / 2, 0, 3.138]}
      />
      <mesh
        geometry={nodes.Text002.geometry}
        material={materials["Material.011"]}
        position={[-16.046, 4.887, -17.088]}
        rotation={[Math.PI / 2, 0, 3.138]}
      />
      <RigidBody colliders="hull" onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh 
        geometry={nodes.Text006.geometry}
        material={materials["Material.006"]}
        position={[5.582, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>
      
      <mesh
        geometry={nodes.Text023.geometry}
        material={nodes.Text023.material}
        position={[-11.104, 8, 0.459]}
        rotation={[0, -0.85, 0]}
        scale={0.496}
      />
      <mesh
        onClick={(e) =>  
          window.open(
          "mailto:teleansh@gmail.com", "_blank")
          }
        geometry={nodes.Cube074.geometry}
        material={materials["Material.002"]}
        position={[-1.898, 3.271, 12.152]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[0.359, 0.17, 0.359]}
      />
      <mesh
        geometry={nodes.Text025.geometry}
        material={materials["Material.011"]}
        position={[-1.62, 2.515, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />
       
     
      <mesh
        geometry={nodes.Text008.geometry}
        material={materials["Material.011"]}
        position={[31.804, 1.614, 10.317]} 
        rotation={[Math.PI / 2, 0, Math.PI]}
      />

      <mesh
        geometry={nodes.Text026.geometry}
        material={materials["Material.011"]}
        position={[-1.033, 2.118, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />
      <mesh
        geometry={nodes.Text031.geometry}
        material={materials["Material.011"]}
        position={[-4.701, 2.118, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />
      <mesh
        geometry={nodes.Text010.geometry}
        material={materials["Material.011"]}
        position={[10.606, 1.614, 10.317]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Cube060.geometry}
        material={materials["Material.012"]}
        position={[5.381, 9.056, 9.379]}
        rotation={[-Math.PI, 0, -Math.PI]}
      />
      <mesh
        geometry={nodes.Cube061.geometry}
        material={materials["Material.012"]}
        position={[5.381, 9.056, 7.049]}
        rotation={[-Math.PI, 0, -Math.PI]}
      />
      <mesh
        geometry={nodes.Cube062.geometry}
        material={materials["Material.012"]}
        position={[5.381, 9.056, 4.664]}
        rotation={[-Math.PI, 0, -Math.PI]}
      />
      <mesh
        geometry={nodes.Cube063.geometry}
        material={materials["Material.012"]}
        position={[5.381, 9.056, 2.161]}
        rotation={[-Math.PI, 0, -Math.PI]}
      />
      <mesh
        geometry={nodes.Cube064.geometry}
        material={materials["Material.012"]}
        position={[5.381, 9.056, -0.249]}
        rotation={[-Math.PI, 0, -Math.PI]}
      />
      <mesh
        geometry={nodes.Cube065.geometry}
        material={materials["Material.012"]}
        position={[5.381, 10.021, 4.337]}
        rotation={[-Math.PI / 2, 0, -Math.PI]}
        scale={[1, 7.595, 1]}
      />


      <mesh
        geometry={nodes.Cube066.geometry}
        material={materials["Material.013"]}
        position={[41.72, 6.158, 10.867]}
        rotation={[-Math.PI, -Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.Cube067.geometry}
        material={materials["Material.013"]}
        position={[31.611, 6.158, 10.867]}
        rotation={[-Math.PI, -Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.Cube068.geometry}
        material={materials["Material.013"]}
        position={[21.571, 6.158, 10.867]}
        rotation={[-Math.PI, -Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.Cube069.geometry}
        material={materials["Material.013"]}
        position={[10.717, 6.158, 10.867]}
        rotation={[-Math.PI, -Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.Cube070.geometry}
        material={materials["Material.013"]}
        position={[7.159, 6.158, 5.258]}
        rotation={[-Math.PI, 0, 0]}
      />
      <mesh
        geometry={nodes.Cube071.geometry}
        material={materials["Material.013"]}
        position={[7.159, 6.158, -1.484]}
        rotation={[-Math.PI, 0, 0]}
      />
      <mesh
        geometry={nodes.Text013.geometry}
        material={materials["Material.011"]}
        position={[-3.636, 4.92, -15.322]}
        rotation={[Math.PI / 2, 0, 0]}
      />
        <RigidBody colliders="hull"  onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh
        geometry={nodes.Text014.geometry}
        material={materials["Material.006"]}
        position={[2.405, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>

<RigidBody  colliders="hull" onCollisionEnter={({e}) => {
         collision.play();
        ;} }>
      <mesh
        geometry={nodes.Text015.geometry}
        material={materials["Material.006"]}
        position={[0.909, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>  <RigidBody colliders="hull"  onCollisionEnter={({e}) => {
        collision.play();
       ;} }>
      <mesh
        geometry={nodes.Text016.geometry}
        material={materials["Material.006"]}
        position={[-0.583, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>  <RigidBody colliders="hull" onCollisionEnter={({e}) => {
        collision.play();
       ;} }>
      <mesh
        geometry={nodes.Text017.geometry}
        material={materials["Material.006"]}
        position={[-1.869, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>  <RigidBody colliders="hull"  onCollisionEnter={({e}) => {
        collision.play();
       ;} }>
      <mesh
        geometry={nodes.Text018.geometry}
        material={materials["Material.006"]}
        position={[-3.281, 0.507, -21.355]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={2.103}
      /></RigidBody>
      <mesh
        geometry={nodes.Cube073.geometry}
        material={materials["Material.003"]}
        position={[-19.972, 2.712, 11.939]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={1.073}
      />
      <mesh
        geometry={nodes.Text019.geometry}
        material={materials["Material.009"]}
        position={[-19.793, 2.224, 11.436]}
        rotation={[Math.PI / 2, 0, Math.PI]}
      />
      <mesh
        geometry={nodes.Curve002.geometry}
        material={materials["Material.016"]}
        position={[-5.838, 3.393, 12.04]}
        rotation={[1.489, -0.032, -3.12]}
        scale={[100.439, 258.273, 100.439]}
      />
      <mesh
        geometry={nodes.Cube076.geometry}
        material={materials["Material.004"]}
        position={[-8.398, 7.374, 12.179]}
        rotation={[Math.PI / 2, Math.PI / 2, 0]}
      />
      <mesh
        geometry={nodes.Text020.geometry}
        material={materials["Material.011"]}
        position={[-18.498, 4.92, -15.899]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={0.459}
      />
      <mesh
       onClick={(e) =>  
        window.open(
        "https://www.linkedin.com/in/anshanandp/", "_blank")
        }
        geometry={nodes.Cube075.geometry}
        material={materials["Material.008"]}
        position={[2.205, 3.234, 12.168]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[1, 0.708, 1]}
      />
      <mesh
        geometry={nodes.Text027.geometry}
        material={materials["Material.011"]}
        position={[2.43, 2.979, 12.04]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.632}
      />
      <mesh
        geometry={nodes.Text028.geometry}
        material={materials["Material.011"]}
        position={[2.575, 2.515, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />
      <mesh
        geometry={nodes.Text030.geometry}
        material={materials["Material.011"]}
        position={[-5.538, 2.515, 11.918]}
        rotation={[Math.PI / 2, 0, 3.138]}
        scale={0.224}
      />

      <RigidBody type="fixed">
      <mesh  receiveShadow 
        geometry={nodes.Plane002.geometry}
        material={materials["Material.001"]}
        position={[5.053, -0.1, -10.272]}
        scale={[64.104, 72.116, 60.587]}
      />
      <mesh
        geometry={nodes.Cube077.geometry}
        material={materials["Vue Green 01"]}
        position={[-57.951, 3.157, -11.592]}
      />
      <mesh
        geometry={nodes.Cube078.geometry}
        material={materials["Vue Green 01"]}
        position={[67.537, 3.157, -11.47]}
      />
      <mesh
        geometry={nodes.Cube079.geometry}
        material={materials["Vue Green 01"]}
        position={[4.845, 3.157, 49.066]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[1, 1, 1.05]}
      />
      <mesh
        geometry={nodes.Cube080.geometry}
        material={materials["Vue Green 01"]}
        position={[4.845, 3.157, -71.871]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[1, 1, 1.05]}
      /> </RigidBody>
      <mesh
        geometry={nodes.Text032.geometry}
        material={materials["Material.011"]}
        position={[3.277, 5.938, -17]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={0.35}
      />
      <mesh
        onClick={(e) =>  
          window.open(
          "https://www.youtube.com/@AnshAnandHere", "_blank")
          }
        geometry={nodes.channels4_profile.geometry}
        material={materials.channels4_profile}
        position={[-9.253, 9.093, 0.518]}
        rotation={[Math.PI / 2, 0, 0.85]}
        scale={2.589}
      />
      <mesh
       onClick={(e) =>  
        window.open(
        "https://www.youtube.com/@honestfreak", "_blank")
        }
        geometry={nodes["channels4_profile_(1)"].geometry}
        material={materials["channels4_profile (1)"]}
        position={[-1.244, 8.958, -0.779]}
        rotation={[Math.PI / 2, 0, 0.85]}
        scale={2.589}
      />
      <mesh
      onClick={(e) =>  
        window.open(
        "https://github.com/teleansh/Baghabot-Telegram-Bot-Python", "_blank")
        }
        geometry={nodes.telebot.geometry}
        material={materials.telebot}
        position={[5.837, 3.65, -1.721]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        scale={2.902}
      />
      <mesh
        geometry={nodes.react.geometry}
        material={materials.react}
        position={[-9.484, 2.817, 9.141]}
        rotation={[0, 0, -Math.PI / 2]}
        scale={2.107}
      />
      <mesh
        geometry={nodes.opencv.geometry}
        material={materials.opencv}
        position={[-22.545, 2.883, 9.563]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        scale={1.429}
      />
      <mesh
       onClick={(e) =>  
        window.open(
        "https://play.google.com/store/apps/details?id=io.kodular.teleansh.IndigoBrowser&hl=en_IN&gl=US&pli=1", "_blank")
        }
        geometry={nodes.indigo.geometry}
        material={materials.indigo}
        position={[10.674, 3.636, 12.095]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={3.06}
      />
      <mesh
        onClick={(e) =>  
            window.open(
            "https://store.steampowered.com/app/2114860/Gumnaam/", "_blank")
            }
        geometry={nodes.gumnaam.geometry}
        material={materials.gumnaam}
        position={[31.635, 3.605, 12.12]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={2.963}
      />
      <mesh
         onClick={(e) =>  {
         if(PointerLockControls.islocked)
         console.log('hi')
         window.open("https://www.icsehub.com", "_blank")}
          }
        geometry={nodes.icsehub.geometry}
        material={materials.icsehub}
        position={[41.804, 3.604, 12.076]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={[3.631, 3.369, 3.369]}
      />
      <RigidBody type="fixed">
      <mesh receiveShadow
        geometry={nodes.Plane.geometry}
        material={materials.gumnaam_promo2}
        position={[5.053, 0, -15.947]}
        scale={[42.222, 47.499, 29.876]}
      /></RigidBody>
      <mesh
        onClick={(e) =>  
          window.open(
          "https://play.google.com/store/apps/developer?id=Parihar&hl=en_IN&gl=US", "_blank")
          }
        geometry={nodes.apps.geometry}
        material={materials.apps}
        position={[5.893, 3.42, 5.669]}
        rotation={[Math.PI / 2, 0, -Math.PI / 2]}
        scale={[3.966, 3.002, 3.462]}
      />
      <mesh
       onClick={(e) =>  
        window.open(
        "https://github.com/teleansh/Behenlang", "_blank")
        }
        geometry={nodes.behenlang.geometry}
        material={materials.behenlang}
        position={[21.219, 3.655, 12.037]}
        rotation={[Math.PI / 2, 0, Math.PI]}
        scale={[3.041, 2.95, 2.95]}
      />
    </group>
  );
}

useGLTF.preload("/campus-v1.glb");
